export default __webpack_public_path__ + "static/media/top.b109bc95.svg";